import * as React from 'react';
import { BorderedInfoTable, BorderedInfoTableField } from '../../components/DataDisplay/BorderedInfoTable';
import { RvLabel, LabelStyle } from '../../components/Label/Label';
import { MatterTopicData } from './MatterDataTopicInfo';
import glamorous, { ThemeProvider } from 'glamorous';
import { mainTheme } from '../../Theme';
import { DataType, labelAndValueFormatter } from '../../components/DataDisplayV2/ValueFormatter';

// tslint:disable-next-line:no-any
const DescriptionWrapper = glamorous.div<{ theme?: any }>((props) => ({
    color: props.theme.BrandColors.TemplatePrimary,
    textAlign: 'left',
    padding: '0 0 1rem 0'
}));

interface DataTopicInfoProps {
    description?: string;
    data: Array<MatterTopicData>;
}

export class RvDataTopicInfo extends React.Component<DataTopicInfoProps, {}>  {

    public render() {
        //  override terminology here if necessary
        // Explicit bug report: LabelStyle.Heading1 resolves to RvLabel's own '2.0rem' (32px)
        // preset - sized for a page-level heading, not a description sitting inside a compact
        // info panel. cssStyle overrides that preset's fontSize (RvLabel spreads cssStyle after
        // the style-derived size), matching the sub-heading weight already used elsewhere
        // (e.g. Parties.tsx's own PartyDescriptionText).
        let topicDescription = this.props.description
            ? (
                <DescriptionWrapper className="topicwrapper">
                    <RvLabel label={this.props.description} style={LabelStyle.Heading1} cssStyle={{ fontSize: '15px', fontWeight: 600 }} />
                </DescriptionWrapper>
            )
            : null;

        let topicItems = this.props.data;
        let fields: BorderedInfoTableField[] = topicItems.map((topic, idx) => {
            var value;
            switch (topic.type) {
                default:
                    value = topic.stringValue;
                    break;
                case DataType.Date:
                    value = topic.dateValue;
                    break;
            }

            return labelAndValueFormatter(topic.type, topic.label ? topic.label : '', value ? value : '',
                                          topic.dateFormat ? topic.dateFormat : '', idx.toString());
        });

        return (
            <ThemeProvider theme={mainTheme}>
                {/* glamorous's ThemeProvider requires exactly one child (React.Children.only
                    internally) - this div is that single child, wrapping topicDescription and
                    BorderedInfoTable together instead of passing them as two siblings. */}
                <div>
                    {topicDescription}
                    <BorderedInfoTable fields={fields} />
                </div>
            </ThemeProvider>
        );

    }
}